module.exports = __webpack_public_path__ + "img/Flag_of_Saint-Pierre_and_Miquelon.b8c36135.svg";